var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export var CheckIcon = function () {
    return (_jsx("svg", { xmlns: "http://www.w3.org/2000/svg", width: "24", height: "24", viewBox: "0 0 24 24", fill: "none", stroke: "currentColor", strokeWidth: "2", strokeLinecap: "round", strokeLinejoin: "round", className: "lucide lucide-check-icon lucide-check", children: _jsx("path", { d: "M20 6 9 17l-5-5" }) }));
};
export var CopyIcon = function () {
    return (_jsxs("svg", { xmlns: "http://www.w3.org/2000/svg", width: "24", height: "24", viewBox: "0 0 24 24", fill: "none", stroke: "currentColor", strokeWidth: "2", strokeLinecap: "round", strokeLinejoin: "round", className: "lucide lucide-copy-icon lucide-copy", children: [_jsx("rect", { width: "14", height: "14", x: "8", y: "8", rx: "2", ry: "2" }), _jsx("path", { d: "M4 16c-1.1 0-2-.9-2-2V4c0-1.1.9-2 2-2h10c1.1 0 2 .9 2 2" })] }));
};
import { ASSET_ICON_URLS, parseAssetCode } from "../const";
var iconImgProps = { width: 44, height: 44 };
export var ETH = function (props) { return (_jsx("img", __assign({ src: ASSET_ICON_URLS.ETH, alt: "Ethereum" }, iconImgProps, props))); };
export var POL = function (props) { return (_jsx("img", __assign({ src: ASSET_ICON_URLS.POL, alt: "Polygon" }, iconImgProps, props))); };
export var BNB = function (props) { return (_jsx("img", __assign({ src: ASSET_ICON_URLS.BNB, alt: "BNB" }, iconImgProps, props))); };
export var ARB = function (props) { return (_jsx("img", __assign({ src: ASSET_ICON_URLS.ARB, alt: "Arbitrum" }, iconImgProps, props))); };
export var Base = function (props) { return (_jsx("img", __assign({ src: ASSET_ICON_URLS.BASE, alt: "Base" }, iconImgProps, props))); };
export var USDC = function (props) { return (_jsx("img", __assign({ src: ASSET_ICON_URLS.USDC, alt: "USDC" }, iconImgProps, props))); };
export var EURC = function (props) { return (_jsx("img", __assign({ src: ASSET_ICON_URLS.EURC, alt: "EURC" }, iconImgProps, props))); };
export var USDT = function (props) { return (_jsx("img", __assign({ src: ASSET_ICON_URLS.USDT, alt: "USDT" }, iconImgProps, props))); };
export var USDT0 = function (props) { return (_jsx("img", __assign({ src: ASSET_ICON_URLS.USDT0, alt: "USDT0" }, iconImgProps, props))); };
export var Stellar = function (props) { return (_jsx("img", __assign({ src: ASSET_ICON_URLS.XLM, alt: "Stellar" }, iconImgProps, props))); };
var ASSET_ICON_MAP = {
    USDC: USDC,
    USDT: USDT,
    USDT0: USDT0,
    EURC: EURC,
    BASE: Base,
    ETH: ETH,
    POL: POL,
    BNB: BNB,
    ARB: ARB,
};
export function getAssetIcon(amountAsset, props) {
    var code = (parseAssetCode(amountAsset) || "USDC").toUpperCase();
    if (code === "NATIVE" || code === "XLM")
        return _jsx(Stellar, __assign({}, iconImgProps, props));
    var Icon = ASSET_ICON_MAP[code];
    // Unknown assets get no icon rather than a misleading USDC one.
    return Icon ? _jsx(Icon, __assign({}, iconImgProps, props)) : null;
}
